<div [formGroup]="form">
  <div class="card mt-3">
    <div class="float-start card-header card-header-detail" i18n>Frühere Aufenthalte in der Bundesrepublik Deutschland</div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label for="fruehereReisen.aufenthalteVorhanden" i18n>Haben Sie sich bereits früher in der Bundesrepublik Deutschland aufgehalten?</label>
            <div>
              <input type="checkbox"
                     class="ms-0 mt-2 form-check-input"
                     value="AufenthaltBRDJa"
                     [class.is-invalid]="errorClassRequired(form.controls['AufenthaltBRDJa'])"
                     formControlName="AufenthaltBRDJa"
                     id="fruehereReisen.aufenthalteVorhanden"
                     [ngbPopover]="popAufenthaltBRDJa"
                     appSaveLastFocussed
              >
              <span class="ms-3" i18n>ja</span>
              <ng-template #popAufenthaltBRDJa>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte aktivieren Sie dieses Feld, wenn Sie bereits früher in Deutschland waren. Sie können maximal fünf frühere Aufenthalte angeben.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="form.value.AufenthaltBRDJa">
        <span i18n>Bitte geben Sie Zeiten und Aufenthaltsorte der letzten fünf Aufenthalte an.</span>
        <div class="row">
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[0].von" [class.mandatory]="isMandatory('aufenthaltVon1')" i18n>von (TT.MM.JJJJ):</label><br>
              <input id="fruehereReisen.aufenthaltListe[0].von"
                     type="text"
                     appDynamicDateMaxLength
                     appFixDate="past"
                     unknownReplacement="00"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltVon1'])"
                     formControlName="aufenthaltVon1"
                     [ngbPopover]="popAufenthaltVon"
                     appSaveLastFocussed
              >
              <ng-template #popAufenthaltVon>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte geben Sie hier im Format TT.MM.JJJJ an, wann der jeweilige Aufenthalt begann. Wenn Ihnen nur noch Monat und Jahr erinnerlich sind, tragen Sie für den Tag bitte 00 ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[0].bis" [class.mandatory]="isMandatory('aufenthaltBis1')" i18n>bis (TT.MM.JJJJ):</label><br>
              <input id="fruehereReisen.aufenthaltListe[0].bis"
                     type="text"
                     appDynamicDateMaxLength
                     appFixDate="past"
                     unknownReplacement="00"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltBis1'])"
                     formControlName="aufenthaltBis1"
                     [ngbPopover]="popAufenthaltBis"
                     appSaveLastFocussed
              >
              <ng-template #popAufenthaltBis>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte geben Sie hier im Format TT.MM.JJJJ an, wann der jeweilige Aufenthalt endete. Wenn Ihnen nur noch der Monat und das Jahr erinnerlich sind, tragen Sie für den Tag bitte 00 ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[0].ort" [class.mandatory]="isMandatory('aufenthaltOrt1')" i18n>in:</label><br>
              <input id="fruehereReisen.aufenthaltListe[0].ort"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('aufenthaltOrt1')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltOrt1'])"
                     formControlName="aufenthaltOrt1"
                     [ngbPopover]="popAufenthaltOrt"
                     appSaveLastFocussed
              >
              <ng-template #popAufenthaltOrt>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier ein, wo Sie sich in Deutschland aufgehalten haben. Die Angabe mehrerer Orte ist möglich.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="form.value.aufenthaltVon1 || form.value.aufenthaltBis1 || form.value.aufenthaltOrt1
                             || form.value.aufenthaltVon2 || form.value.aufenthaltBis2 || form.value.aufenthaltOrt2">
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[1].von" [class.mandatory]="isMandatory('aufenthaltVon2')" i18n>von (TT.MM.JJJJ):</label><br>
              <input id="fruehereReisen.aufenthaltListe[1].von"
                     type="text"
                     appDynamicDateMaxLength
                     appFixDate="past"
                     unknownReplacement="00"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltVon2'])"
                     formControlName="aufenthaltVon2"
                     [ngbPopover]="popAufenthaltVon"
                     appSaveLastFocussed
              >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[1].bis" [class.mandatory]="isMandatory('aufenthaltBis2')" i18n>bis (TT.MM.JJJJ):</label><br>
              <input id="fruehereReisen.aufenthaltListe[1].bis"
                     type="text"
                     [attr.maxlength]="getMaxLength('aufenthaltBis2')"
                     appFixDate="past"
                     unknownReplacement="00"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltBis2'])"
                     formControlName="aufenthaltBis2"
                     [ngbPopover]="popAufenthaltBis"
                     appSaveLastFocussed
              >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[1].ort" [class.mandatory]="isMandatory('aufenthaltOrt2')" i18n>in:</label><br>
              <input id="fruehereReisen.aufenthaltListe[1].ort"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('aufenthaltOrt2')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltOrt2'])"
                     formControlName="aufenthaltOrt2"
                     [ngbPopover]="popAufenthaltOrt"
                     appSaveLastFocussed
              >
            </div>
          </div>
        </div>
        <div class="row" *ngIf="form.value.aufenthaltVon2 || form.value.aufenthaltBis2 || form.value.aufenthaltOrt2
                             || form.value.aufenthaltVon3 || form.value.aufenthaltBis3 || form.value.aufenthaltOrt3">
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[2].von" [class.mandatory]="isMandatory('aufenthaltVon3')" i18n>von (TT.MM.JJJJ):</label><br>
              <input id="fruehereReisen.aufenthaltListe[2].von"
                     type="text"
                     appDynamicDateMaxLength
                     appFixDate="past"
                     unknownReplacement="00"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltVon3'])"
                     formControlName="aufenthaltVon3"
                     [ngbPopover]="popAufenthaltVon"
                     appSaveLastFocussed
              >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[2].bis" [class.mandatory]="isMandatory('aufenthaltBis3')" i18n>bis (TT.MM.JJJJ):</label><br>
              <input id="fruehereReisen.aufenthaltListe[2].bis"
                     type="text"
                     [attr.maxlength]="getMaxLength('aufenthaltBis3')"
                     appFixDate="past"
                     unknownReplacement="00"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltBis3'])"
                     formControlName="aufenthaltBis3"
                     [ngbPopover]="popAufenthaltBis"
                     appSaveLastFocussed
              >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[2].ort" [class.mandatory]="isMandatory('aufenthaltOrt3')" i18n>in:</label><br>
              <input id="fruehereReisen.aufenthaltListe[2].ort"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('aufenthaltOrt3')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltOrt3'])"
                     formControlName="aufenthaltOrt3"
                     [ngbPopover]="popAufenthaltOrt"
                     appSaveLastFocussed
              >
            </div>
          </div>
        </div>
        <div class="row" *ngIf="form.value.aufenthaltVon3 || form.value.aufenthaltBis3 || form.value.aufenthaltOrt3
                             || form.value.aufenthaltVon4 || form.value.aufenthaltBis4 || form.value.aufenthaltOrt4">
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[3].von" [class.mandatory]="isMandatory('aufenthaltVon4')" i18n>von (TT.MM.JJJJ):</label><br>
              <input id="fruehereReisen.aufenthaltListe[3].von"
                     type="text"
                     appDynamicDateMaxLength
                     appFixDate="past"
                     unknownReplacement="00"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltVon4'])"
                     formControlName="aufenthaltVon4"
                     [ngbPopover]="popAufenthaltVon"
                     appSaveLastFocussed
              >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[3].bis" [class.mandatory]="isMandatory('aufenthaltBis4')" i18n>bis (TT.MM.JJJJ):</label><br>
              <input id="fruehereReisen.aufenthaltListe[3].bis"
                     type="text"
                     [attr.maxlength]="getMaxLength('aufenthaltBis4')"
                     appFixDate="past"
                     unknownReplacement="00"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltBis4'])"
                     formControlName="aufenthaltBis4"
                     [ngbPopover]="popAufenthaltBis"
                     appSaveLastFocussed
              >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[3].ort" [class.mandatory]="isMandatory('aufenthaltOrt4')" i18n>in:</label><br>
              <input id="fruehereReisen.aufenthaltListe[3].ort"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('aufenthaltOrt4')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltOrt4'])"
                     formControlName="aufenthaltOrt4"
                     [ngbPopover]="popAufenthaltOrt"
                     appSaveLastFocussed
              >
            </div>
          </div>
        </div>
        <div class="row" *ngIf="form.value.aufenthaltVon4 || form.value.aufenthaltBis4 || form.value.aufenthaltOrt4
                             || form.value.aufenthaltVon5 || form.value.aufenthaltBis5 || form.value.aufenthaltOrt5">
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[4].von" [class.mandatory]="isMandatory('aufenthaltVon5')" i18n>von (TT.MM.JJJJ):</label><br>
              <input id="fruehereReisen.aufenthaltListe[4].von"
                     type="text"
                     appDynamicDateMaxLength
                     appFixDate="past"
                     unknownReplacement="00"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltVon5'])"
                     formControlName="aufenthaltVon5"
                     [ngbPopover]="popAufenthaltVon"
                     appSaveLastFocussed
              >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[4].bis" [class.mandatory]="isMandatory('aufenthaltBis5')" i18n>bis (TT.MM.JJJJ):</label><br>
              <input id="fruehereReisen.aufenthaltListe[4].bis"
                     type="text"
                     [attr.maxlength]="getMaxLength('aufenthaltBis5')"
                     appFixDate="past"
                     unknownReplacement="00"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltBis5'])"
                     formControlName="aufenthaltBis5"
                     [ngbPopover]="popAufenthaltBis"
                     appSaveLastFocussed
              >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <label for="fruehereReisen.aufenthaltListe[4].ort" [class.mandatory]="isMandatory('aufenthaltOrt5')" i18n>in:</label><br>
              <input id="fruehereReisen.aufenthaltListe[4].ort"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('aufenthaltOrt5')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['aufenthaltOrt5'])"
                     formControlName="aufenthaltOrt5"
                     [ngbPopover]="popAufenthaltOrt"
                     appSaveLastFocussed
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
